import { ICampaignBlock } from '@models/ICampaignBlock';
import SharedCampaignBlock from '@organisms/CampaignBlock/CampaignBlock';

const CampaignBlock = (props: ICampaignBlock) => (
  <div className="tw-component-margin">
    <SharedCampaignBlock {...props} />
  </div>
);

export default CampaignBlock;
